import { ContentEventParagraphSectionAction } from '../types/ContentInSectionAction';

interface EventParaghState {
    list: any,
    error: any,
    createScenarioData: any,
    questionData: any,
    hintData: any,
    syllabusData: any,
    skillData: any
};

const initialParaghState: EventParaghState = {
    list: {},
    error: {},
    createScenarioData: {},
    questionData: {},
    hintData: {},
    syllabusData: {},
    skillData: {},

};

const contentInParaghSectionReducers = (state = initialParaghState, action: ContentEventParagraphSectionAction) => {
    switch (action.type) {
        case 'Content_In_Section_Paragraph_Event': {
            return { ...state, list: action.data }
        }
        case 'Content_In_Section_Paragraph_Event_Error': {
            return { ...state, error: action.error }
        }
        case 'SET_CREATE_SCENARIO_DATA': {
            return { ...state, createScenarioData: action.data }
        }
        case 'SET_QUESTION_DATA': {
            return { ...state, questionData: action.data }
        }
        case 'SET_HINT_DATA': {
            return { ...state, hintData: action.data }
        }
        case 'SET_SYLLABUS_DATA': {
            return { ...state, syllabusData: action.data }
        }
        case 'SET_DIFFICULTY_AND_SKILL_DATA': {
            return { ...state, skillData: action.data }
        } 
        case 'SET_PARAGRAPH_SECTIONS': {
            return { ...state, createScenarioData: action.data.createScenarioData }
        } 
        default:
            return state;
    }
}


export { contentInParaghSectionReducers };
